

import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Select, MenuItem, Button, Collapse, Card, CardContent, Checkbox, Popover, FormGroup, FormControlLabel } from "@mui/material";
import {
  getCountryAssetMasterDataList,
  getFamilyAssetMasterDataList,
  getInspectionTemplateColumnDetails,
  getListOfSavedInspection,
  getListOfSavedService,
  getListOfServiceTemplate,
} from "../../api/Services/masterServie";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage, Loader } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { createFaultData, deleteInspection, getAssetMappingData, getPrevFaultByUserIdData, getUniqueAssetNamesByFamilyId, handleInspectionFilter, handleLogisticsFilter, saveServiceData } from "../../api/Services/assetServices";
import FamilyAsset from "./FamilyAsset";
import { assetFamilyMaster, assetType, attachments, CountryMaster, FaultAssetMapMaster, FaultAssetMappingMaster, InspectionColumn, InspectionColumnDataPayload, InspectionReportPayload, } from "../../types/assetTypes";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
} from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";

import dayjs from "dayjs";
import { useRef } from "react";
import Logo from "../../assets/companyLogo.png";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import ChooseCam from "@mui/icons-material/Camera";
import "react-html5-camera-photo/build/css/index.css";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import { base64ToFile } from "../../const/const";
import { FILE_DOWNLOAD_PREVIEW } from "../../api/endpoint";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { uploadFiles } from "../../api/Services/assetServices";
import { RootState } from "../../store/Reduxstore";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate } from "react-router-dom"; // Import navigate
import { DataTable } from "primereact/datatable";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { templateBodyTableIcon, getServiceTemplateColumns, getTemplateButtonData, saveServiceBodyTableIcon, savedServiceColumns, saveInspectionBodyTableIcon, savedInspectionColumns, getTemplateBButtonData, getTemplateExportData } from "../../const/AssertData";
import CreateTemplate from "./CreateService";
import ServiceCreatingForm from "./ServiceCreatingForm";
import InspectionCreatingForm from "./InspectionCreatingForm";
import InspectionEditingForm from "./InspectionEditingForm";
import FilterListIcon from '@mui/icons-material/FilterList';
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
interface ServiceFormProps {
  setPathname: (path: string) => void;
}

//import { assetType } from "../../types/assetTypes";
const InspectionForm: React.FC = () => {
  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();


  const [selectedData, setSelectedData] = useState<InspectionReportPayload>({
    inspectionReportingId: 0,
    user_id: 0,
    date: new Date,
    assetName: "",
    name: "",
    familyAssetId: 0,
    familyName: "",
    inspectionTemplateId: 0,
    inspectionTemplateName: "",
    currentLocationId: 0,
    countryName: "",
    regionId: 0,
    regionName: "",
    projectId: 0,
    projectName: "",
    service: "",
    details: [],
    commonComments: "",
    engineHours: "",
    serviceName: "",
  });
  const [products, setProducts] = useState<InspectionReportPayload[]>([]);
  const [open, setOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [inspectionTemplateData, setInspectionTemplateData] = useState<InspectionColumn[]>([]);
  const [selectedRowData, setSelectedRowData] = useState<InspectionReportPayload | null>(null);
  const [editOpen, setEditOpen] = useState(false);

  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });

  const handleDeleteInspection = async (inspectionReportingId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result: { isConfirmed: any; }) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
        try {
          const response = await deleteInspection(inspectionReportingId);
          if (response.status === 200) {
            onFetchData(paginationData.page, paginationData.rows, filterData);
            CustomMessage("Data deleted", "success", enqueueSnackbar);
          } else {
            CustomMessage(
              "Failed to delete the asset.",
              "error",
              enqueueSnackbar
            );
          }
        } catch (error: any) {
          CustomMessage(
            error?.message || "Something went wrong!",
            "error",
            enqueueSnackbar
          );
        } finally {
          dispatch(setLoading(false));
        }
      } else {
        CustomMessage("Deletion cancelled", "info", enqueueSnackbar);
      }
    });
  };

  const actionBodyTemplate = (rowData: InspectionReportPayload) => {
    const renderIconData = saveInspectionBodyTableIcon(
      handleEditSaveInspectionTemplate,
      handleDeleteInspection,
      rowData
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const columns = savedInspectionColumns(actionBodyTemplate);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );


  const handleClearFilter = () => {
    // Clear filters and related UI states
    setFilterData({});
    setTempFilters({});
    // setCheckedValues([]);
    setSelectedValues([]);
    setFilterCol("");
    setSearchText("");
    setSubAnchorEl(null); // Close second popover if open
    setAnchorEl(null);
    setFilters({});    // Close first popover if open

    // Refetch data without any filters
    onFetchData(paginationData.page, paginationData.rows, {});
  };
  //for unique column names 

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  // const [filterCol, setFilterCol] = useState<string | null>(null);


  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[]; // Optional if values might not always exist
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);
    setFilterCol(col.key);
    setSelectedValues(col.values || []);
  };

  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);

    setSearchText(''); // clear search input
  };

  type Filters = {
    [key: string]: {
      value: string[];
    };
  };


  type AssetItem = {
    id: number;
    name: string;
  };
  // const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});
  const [filters, setFilters] = useState<Filters>({});
  const [tempFilters, setTempFilters] = useState<Filters>({}); // ✨ temporary filters
  const [filterCol, setFilterCol] = useState<string>('');

  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    console.log("Updated filterCol inside useEffect:", filterCol);
  }, [filterCol]);


  const [columnData, setColumnData] = useState<AssetColumnData>({});
  const currentColValues = (columnData[filterCol] || []).map((item: { name: string }) => item.name);
  const filteredValues = currentColValues.filter((val: string) =>
    val.toLowerCase().includes(searchText.toLowerCase())
  );



  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {

    closeSubPopover();     // ✅ Close the popover
  };

  const openVisibilityPopover = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget); // Anchor the popover

    // Fetch asset column data on click
    dispatch(setLoading(true));

    try {
      const response = await handleInspectionFilter(); // Get the full response

      console.log("API Response:", response); // Log the full response

      // Check if the response is valid and contains the 'data' object
      if (response && response.status && response.status.code === 200 && response.data) {
        const data = response.data;

        setColumnData(data); // Store the full data, if needed for later

        // Map through each key in the response's data object
        const formattedCols = Object.keys(data).map((key) => ({
          key,
          label: key.replace(/_/g, " "), // Make the key more readable by replacing underscores with spaces
          values: data[key].map((item: { name: string }) => item.name), // Access the 'name' property of each object
        }));

        console.log("Formatted Columns:", formattedCols); // Log formatted columns for debugging
        setColumns(formattedCols); // Store formatted columns in state
      } else {
        // If response does not contain valid data, show an error message
        CustomMessage("Failed to fetch valid data", "error", enqueueSnackbar); // Custom error message
      }
    } catch (error: any) {
      // Handle any errors and display custom error messages
      CustomMessage(error.message, "error", enqueueSnackbar); // Custom error message on failure
    } finally {
      // Stop the loading indicator when the request completes (success or error)
      dispatch(setLoading(false));
    }
  };
  // Generate button data dynamically
  const userDetails = useSelector((state: RootState) => state.auth);
  const exportCSV = (selectionOnly: boolean) => {
    if (!dt.current) {
      alert("No data available to export.");
      return;
    }

    // Get table data from PrimeReact's DataTable
    const data = dt.current.props.value || [];

    if (selectionOnly) {
      const selectedData = dt.current.props.selection || [];
      if (selectedData.length === 0) {
        alert("No rows selected for export.");
        return;
      }
      exportToExcel(selectedData);
    } else {
      exportToExcel(data);
    }
  };

  const exportToExcel = (data: any[]) => {
    if (!data || data.length === 0) {
      alert("No data to export.");
      return;
    }

    console.log("Export data row example:", data[0]);


    const rows = data.map((row) => ({
      "Id": row.inspectionReportingId,
      "Asset Type": row.familyName,
      "Asset Name": row.assetName,
      "User Name": row.name,
      "Service Date": row.date ? new Date(row.date).toLocaleDateString() : "",
      "Service No": row.service,
      "Service Template": row.serviceTemplateName,
      "Project": row.projectName,
      "Region": row.regionName,
      "Country": row.countryName,
      "Engine Hours": row.engineHours,
      "Comments": row.commonComments,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();

    // Step 3: Apply hyperlinks
    const range = XLSX.utils.decode_range(worksheet["!ref"] || "");
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const currentRow = data[R - 1]; // Map to original data

      const columns = [
        { key: "Asset Image", id: currentRow.imageAttachmentId },
        { key: "Capex Attachment", id: currentRow.capexAttachmentId },
        { key: "Logistics Attachment", id: currentRow.logisticsAttachmentId },
      ];

      columns.forEach((col) => {
        const colIndex = Object.keys(rows[0]).indexOf(col.key);
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: colIndex });

        if (worksheet[cellAddress] && worksheet[cellAddress].v.startsWith("Download") && col.id) {
          worksheet[cellAddress].l = {
            Target: FILE_DOWNLOAD_PREVIEW + col.id,
            Tooltip: "Click to download",
          };
          worksheet[cellAddress].s = {
            font: { color: { rgb: "0000FF" }, underline: true },
          };
        }
      });
    }

    // Step 4: Format headers
    const headerRow = Object.keys(rows[0]);
    worksheet["!cols"] = headerRow.map(() => ({ wch: 25 }));

    headerRow.forEach((col, index) => {
      const cellAddress = XLSX.utils.encode_col(index) + "1";
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "0074D9" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    // Step 5: Finalize and download
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };
  const buttonData = getTemplateExportData(
    handleClearFilter,
    () => setOpen(true),
    openVisibilityPopover,
    { role: userDetails.role.map(r => r.roleName) },
    exportCSV

  );
  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          gap: "16px",
          width: "100%",
        }}
      >
        {/* Icons (Buttons) and Search Box in the Same Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Left Side - Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => <ReusablePrimeButton key={val.label} {...val} />)}
          </div>

          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={closeVisibilityPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <FormGroup sx={{ p: 2, minWidth: 220 }}>
              {columnns.map((col) => (
                <Box
                  key={col.key}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    px: 1,
                    py: 0.5,
                    '&:hover': { backgroundColor: '#f5f5f5', borderRadius: 1 },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFilterCol(col.key);

                    const currentChecked =
                      tempFilters[col.key]?.value || filters[col.key]?.value || [];

                    openSubPopover(e, col);
                  }}
                >
                  <Typography variant="body2">{col.label}</Typography>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterCol(col.key);

                      const currentChecked =
                        tempFilters[col.key]?.value || filters[col.key]?.value || [];


                      openSubPopover(e, col); // Pass the full Column object here
                    }}

                  >
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </FormGroup>
          </Popover>

          {/* Second Popover - value checkboxes */}
          <Popover
            open={!!subAnchorEl}
            anchorEl={subAnchorEl}
            onClose={closeSubPopover}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          >
            <Box sx={{ p: 2, width: 250 }}>
              <Typography variant="body2" gutterBottom>
                Filter by {filterCol.replace(/_/g, ' ')}
              </Typography>

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder={`Search ${filterCol}`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ mt: 1 }}
              />

              <Box sx={{ mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={
                        filteredValues.length > 0 &&
                        filteredValues.every((value) =>
                          tempFilters[filterCol]?.value?.includes(value)


                        )
                      }
                      onChange={(e) => {
                        const newChecked = e.target.checked
                          ? Array.from(new Set([
                            ...(tempFilters[filterCol]?.value),
                            ...filteredValues
                          ]))
                          : (tempFilters[filterCol]?.value).filter(
                            (v) => !filteredValues.includes(v)
                          );

                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));
                      }}
                    />
                  }
                  label={<Typography variant="body2">Select All</Typography>}
                />
              </Box>

              <Box sx={{ mt: 1 }}>
                {filteredValues.map((value, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          tempFilters[filterCol]?.value?.includes(value)

                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const current = tempFilters[filterCol]?.value || []; // Ensure current is always an array

                          const updated = isChecked
                            ? [...current, value] // Add value if checked
                            : current.filter((v) => v !== value); // Remove value if unchecked

                          setTempFilters((prev) => ({
                            ...prev,
                            [filterCol]: { value: updated },
                          }));
                        }}
                      />
                    }
                    label={<Typography variant="body2">{value}</Typography>}
                  />
                ))}
              </Box>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const newFilters: Filters = {
                      ...filters,
                      ...tempFilters,
                    };
                    setFilters(newFilters);
                    handleSubmit(newFilters);
                    setSearchText('');
                    closeSubPopover();
                    closeVisibilityPopover();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Popover>
          {/* Right Side - Search Box */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search..."
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px",
              }}
            />
            <button
              onClick={handleSearch}
              style={{
                padding: "8px 12px",
                marginLeft: "8px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#007bff", // Keeping the original color
                color: "white",
                cursor: "pointer",
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleEditSaveInspectionTemplate = async (
    inspectionReportingId: number,
    selectedRow: InspectionReportPayload
  ) => {
    try {
      const { inspectionTemplateId, service } = selectedRow;

      // Fetch inspection template column details
      const response = await getInspectionTemplateColumnDetails(
        inspectionReportingId,
        inspectionTemplateId,
        service
      );

      console.log("API Response:", response); // ✅ Debug API response

      if (response.status.code === 200 && Array.isArray(response.data)) {
        console.log("Received Inspection Template Data:", response.data);

        // ✅ Transform response data to match InspectionColumn structure
        const formattedData: InspectionColumn[] = response.data.map((item: any) => ({
          inspectionColumnId: item.inspectionColumnId,
          inspectionColumnName: item.inspectionColumnName || "Unknown", // Ensure name is present
          attachments: item.attachments || [],
          isChecked: item.isChecked ?? false, // Default to false if missing
          commands: item.commands ?? null, // Default to null if missing
          inspectionAttachments: item.inspectionAttachments ?? []
        }));

        setInspectionTemplateData(formattedData); // ✅ Correctly formatted data
        console.log("df:", inspectionTemplateData);
        setSelectedRowData(selectedRow); // ✅ Store selected row separately
        setEditOpen(true);
      } else {
        console.error("Failed to fetch column details");
      }

    } catch (error) {
      console.error("Error fetching inspection template details:", error);
    }
  };


  // Function to fetch data with pagination, global filter, and field filters
  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfSavedInspection(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        // CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const header = renderHeader();
  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px" }}>
          New Inspection
        </h2>

      </Box>
      {!open && !editOpen ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products} // Pass the data array
            columns={columns} // Pass the columns definition
            onFetchData={onFetchData} // Pass the function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[
              // "assetOwnerName",
              // "harmonyCode",
              // "codeType",
              // "familyAsset",
            ]}
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            //rowsPerPageOptions={[10, 25, 50, 70, 100]}
            filters={filterData}
            setFilters={setFilterData}
            pagination={paginationData}
            setPagination={setPaginationData}
            onRowDoubleClick={(rowData) => {
              console.log('Double-click row:', rowData);
              handleEditSaveInspectionTemplate(rowData.inspectionReportingId, rowData);
            }}
          />
        </Box>
      ) : open ? (  // ✅ Correctly nested ternary condition
        <InspectionCreatingForm
          setOpen={setOpen}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
      ) : editOpen ? (  // ✅ Now correctly placed
        <InspectionEditingForm
          setEditOpen={setEditOpen}
          selectedRowData={selectedRowData}
          inspectionTemplateData={inspectionTemplateData}
        />
      ) : null}

    </div>

  );
};


const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: "1500px",
    width: "90%",
    margin: "50px auto",
    padding: "40px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    textAlign: "center",
    color: "#333",
    marginBottom: "20px",
    fontSize: "26px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
    width: "100%",
  },
  label: {
    fontSize: "16px",
    fontWeight: "bold",
    display: "block",
    marginBottom: "5px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};

export default InspectionForm;



